import { urls } from './url';
import { staticURLs } from './staticURL';

export const environment = {
  production: false,
  host: 'https://ap.appening.xyz/',
  tradeWasteUrl: `https://tw.appening.xyz/`,
  busineslicenseURL: `https://bl.appening.xyz/`,
  frontendUrl: 'https://ap.appening.xyz/',
  cannabisUrl: `https://cb.appening.xyz/`,
  blUrl: `https://bl.appening.xyz/`,
  image_url: 'https://s3.amazonaws.com/licenseportal.us/',
  dogUrl: `https://dog.appening.xyz/`,
  ap: `https://ap.appening.xyz/`,
  ceUrl: 'https://coop-react.appening.xyz/',



  ...urls,
  ...staticURLs,
};
``